import { Button, Card, Image } from "antd";
import styled from "styled-components";

import { StyledContainer } from "../../../shared/styled-components/styled-container.style";

type StyledCardProps = {
  $isActive?: boolean;
};

export const StyledCard = styled(Card).attrs({
  styles: {
    body: { padding: "0.75rem" },
  },
  style: {
    width: "100%",
    margin: "0.25rem",
  },
})<StyledCardProps>`
  cursor: pointer;
  transition: color 0.3s ease;

  border: solid 1px;
  border-color: ${({ $isActive, theme }) =>
    $isActive ? theme.colors.primaryLight : theme.colors.neutral};

  background-color: ${({ $isActive, theme }) =>
    $isActive ? theme.colors.primaryLight : theme.colors.white};
  color: ${({ $isActive, theme }) =>
    $isActive ? theme.colors.primary : theme.colors.default};

  &:hover {
    border: ${({ $isActive, theme }) =>
      $isActive
        ? `solid ${theme.colors.primaryLight} 0.0625rem`
        : `solid ${theme.colors.primary} 0.0625rem`};
    color: ${({ theme }) => theme.colors.primary};
  }
`;

export const StyledContent = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: row;
`;

export const StyledLeftContainer = styled(StyledContainer)`
  width: 12.5rem;
  height: 9.375rem;
  overflow: hidden;
  border-radius: 0.5rem;
  flex-shrink: 0;
  min-width: 0;

  .ant-carousel, //памагите
  .ant-image,
  .ant-image-img,
  .slick-slider,
  .slick-list,
  .slick-track,
  .slick-slide > div {
    height: 9.375rem !important;
  }
`;

export const StyledImage = styled(Image)`
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  object-fit: cover;

  .ant-image-img {
    width: 100% !important;
    height: 100% !important;
    object-fit: cover;
    display: block;
  }
`;

export const StyledRightContainer = styled(StyledContainer)`
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 0 0.75rem;
  font-size: 0.875rem;

  min-height: 9.375rem;
`;

export const StyledTextContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-grow: 1;
`;

export const StyledTitle = styled.h3`
  font-size: 1.125rem;
  line-height: 1.2;
`;

export const StyledParagraph = styled.p`
  padding-top: 0.375rem;
`;

export const StyledButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: end;
`;

export const StyledButton = styled(Button)`
  width: 7.25rem;
  height: 2rem;
  font-size: 0.875rem;
  border-radius: 0.35rem;
`;
